

const missingItems = {
    ["name"]: 'שם',
    ["missing street name"]: 'חסר שם רחוב',
    ["category"]: 'קטגוריה',
    ["description"]: 'תיאור',
    ["date"]: 'תאריך',
    ["time"]: 'שעה',
    ["sub categories"]: 'תת קטגוריה',
    ["instruments"]: 'כלי נגינה',
    ["phone/email/fb link"]: 'טלפוןֿ/מייל/קישור פייסבוק',
    ["i am a"]: 'מי אני?',
    ["we are a"]: 'מי אנחנו?',
    ["looking for"]: 'מה מחפשים?'
}

export const translateMissingItem = item => {
    return item ? missingItems[item.toLowerCase()] : ''
}

export const datepickerLocale = {
    format: "DD/MM/YYYY",
    applyLabel: "אישור",
    cancelLabel: "ביטול",
    customRangeLabel: "מותאם אישית",
    daysOfWeek: [
        "ראשון",
        "שני",
        "שלישי",
        "רביעי",
        "חמישי",
        "שישי",
        "שבת"
    ],
    monthNames: [
        "ינואר",
        "בפרואר",
        "מרץ",
        "אפריל",
        "מאי",
        "יוני",
        "יולי",
        "אוגוסט",
        "ספטמבר",
        "אוקטובר",
        "נובמבר",
        "דצמבר"
    ]
}



// WEBPACK FOOTER //
// ./src/lang.js